<template>
  <div class="column-index">
    <div class="title-mod"  >
      <el-row :gutter="20" v-if="list">
        <el-col :span="16">
          <div class="text">
            {{list.type_name}}
          </div>
        </el-col>
        <el-col :span="8" v-if="list.type_id">
         <div class="am-text-right">
            <router-link class="more" tag="a" :to="'/list/'+list.type_id"><img src="../../assets/images/more.png" alt=""></router-link>
         </div>
        </el-col>
      </el-row>
       <div class="text" v-if="text">
            {{text}}
          </div>
    </div>

    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      list:{
      },
      text:{
        default:''
      }
    }

  }
</script>

<style lang="scss">
  .column-index {

    .content {
    }

    .title-mod {
        height: 28px;
        line-height: 28px;
      border-bottom: 1px solid #5bbffd;
      padding-bottom: 6px;
      .text {
        background-image: url(~@/assets/images/titleBg.jpg);
           border-radius: 6px;
        background-repeat: repeat-x;
        display: inline-block;
        color: white;
        font-size: 14px;
        padding: 0 12px;
     
      }

      .more {
      }
    }
  }
</style>